export default "/048cb1f2b29308e18768c65cfd51e426596a830c/745ea77b1eac57714916b21323fd342f.png";